// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3vZQr","selects":"Documents_selects__2rIVA"};